module.exports = __webpack_public_path__ + "static/star-yellow-5729a3cf2b3a1351e066a734d33cc541.png";